import React, { useEffect, useState } from "react";
import { Calendar, Modal, Tag, Select, message } from "antd";
import {
  CalendarOutlined,
  GiftOutlined,
  PlusCircleOutlined,
  CheckCircleOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  CoffeeOutlined,
  SmileOutlined,
  StarOutlined,
  HeartOutlined,
} from "@ant-design/icons";
import "./style.css";
import "./modal.css";
import { eventAPI } from "../../../utils/api";
import { ClipLoader } from "react-spinners";

const { Option } = Select;

// Array of icons to randomly pick from

const EventCalendar = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventsData, setEventsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();
  const icons = [
    <CoffeeOutlined />,
    <SmileOutlined />,
    <GiftOutlined />,
    <StarOutlined />,
    <HeartOutlined />,
  ];

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const eventsDataRaw = await eventAPI.getCalendarEvents();
        setEventsData(eventsDataRaw.data || []);
      } catch (error) {
        messageApi.error("Failed to load data");
        console.error("Load data error:", error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [messageApi]);

  const clients = [{ id: 1, name: "Joe Root" }];

  const handleOpenModal = (eventId, dateKey) => {
    const event = eventsData[dateKey]?.find((e) => e.id === eventId);
    setSelectedEvent(event || null);
  };

  const dateCellRender = (value) => {
    const dateKey = value.format("DDMMYYYY");

    return (
      <div className="events">
        {eventsData[dateKey]?.map((event) => {
          // Pick a random icon for each event
          const randomIcon = icons[Math.floor(Math.random() * icons.length)];

          return (
            <Tag
              key={event.id}
              color="default"
              style={{
                borderColor: event.color,
                backgroundColor: `${event.color}22`, // light transparent background
                color: `${event.color}`,
                fontWeight: "500",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 6,
                marginBottom: 6,
              }}
              onClick={() => handleOpenModal(event.id, dateKey)}
            >
              {randomIcon}
              {event.title}
            </Tag>
          );
        })}
      </div>
    );
  };

  return loading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="pdf-loader-overlay"
    >
      <ClipLoader size={60} color="#e2ae03" />
    </div>
  ) : (
    <div className="calendar-page">
      {contextHolder}
      <div className="page-header">
        <div className="today">
          <span>Today</span>
        </div>
        {/* <div className="select-options">
          <Select
            showSearch
            placeholder="Select a client"
            optionFilterProp="children"
            onChange={(value) => console.log("Selected client ID:", value)}
            style={{ width: 220 }}
            filterOption={(input, option) =>
              (option?.children ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {clients.map((client) => (
              <Option key={client.id} value={client.id}>
                {client.name}
              </Option>
            ))}
          </Select>
        </div> */}
      </div>

      <Calendar dateCellRender={dateCellRender} />

      <Modal
        open={!!selectedEvent}
        onCancel={() => setSelectedEvent(null)}
        footer={null}
        centered
        width={720}
      >
        {selectedEvent && (
          <div className="modal-content">
            <div className="modal-title">
              <div className="title-wrap">
                <div
                  className="circle"
                  style={{ backgroundColor: selectedEvent.color }}
                />
                <span className="title">{selectedEvent.title}</span>
              </div>
              <span className="date">
                <CalendarOutlined /> {selectedEvent.date}
              </span>
            </div>

            <div className="section">
              <GiftOutlined /> <strong>Package</strong>
              <div className="section-text">{selectedEvent.package}</div>
            </div>

            <div className="section">
              <PlusCircleOutlined /> <strong>Add Ons</strong>
              <div className="addon-checkbox-group">
                {selectedEvent.addOns.map((addon, i) => (
                  <div className="addon-checkbox">
                    <CheckCircleOutlined
                      style={{
                        color: selectedEvent.color,
                        marginRight: 6,
                      }}
                    />
                    {addon}
                  </div>
                ))}
              </div>
            </div>

            <div className="section">
              <div className="section-text">
                <b>Client Name: </b>
                {selectedEvent.client.name}
              </div>
            </div>

            <div className="section">
              <MailOutlined style={{ color: "#3A974C" }} />{" "}
              {selectedEvent.client.email}
            </div>

            <div className="section">
              <PhoneOutlined style={{ color: "#3980F2" }} />{" "}
              {selectedEvent.client.phone}
            </div>
            <div className="section">
              <EnvironmentOutlined /> <strong>Address</strong>
              <div className="section">{selectedEvent.client.address}</div>
            </div>

            <div className="section">
              <FileTextOutlined /> <strong>Client Notes</strong>
              <p className="section-text">{selectedEvent.notes}</p>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default EventCalendar;
